import { User } from "@/types/user";

export function parseUserDates(user: User): User {
  return {
    ...user,
    created_at: new Date(user.created_at),
    updated_at: new Date(user.updated_at),
    saved_job_posts:
      user.saved_job_posts?.map(job => ({
        ...job,
        created_at: new Date(job.created_at),
        updated_at: new Date(job.updated_at),
        time_applied: job.time_applied ? new Date(job.time_applied) : null,
        last_viewed_at: job.last_viewed_at
          ? new Date(job.last_viewed_at)
          : null,
        application_status_updated_at: job.application_status_updated_at
          ? new Date(job.application_status_updated_at)
          : null,
      })) ?? [],
    saved_companies:
      user.saved_companies?.map(company => ({
        ...company,
        created_at: new Date(company.created_at),
        updated_at: new Date(company.updated_at),
        last_viewed_at: company.last_viewed_at
          ? new Date(company.last_viewed_at)
          : null,
        applied_at: company.applied_at ? new Date(company.applied_at) : null,
        last_interaction_at: company.last_interaction_at
          ? new Date(company.last_interaction_at)
          : null,
      })) ?? [],
    user_credentials:
      user.user_credentials?.map(cred => ({
        ...cred,
        created_at: new Date(cred.created_at),
        updated_at: new Date(cred.updated_at),
      })) ?? [],
    user_educations:
      user.user_educations?.map(edu => ({
        ...edu,
        created_at: new Date(edu.created_at),
        updated_at: new Date(edu.updated_at),
      })) ?? [],
    healthcare_domains:
      user.healthcare_domains?.map(hd => ({
        ...hd,
        created_at: new Date(hd.created_at),
        updated_at: new Date(hd.updated_at),
      })) ?? [],
  };
}
